import { RootInitialState } from 'core/common/store';

export const getUserLocation = (state: RootInitialState) => {
  return state.userLocation.location;
};

export const getUserLocationLoadingStatus = (state: RootInitialState) => {
  return state.userLocation.loadingStatus;
};
